import {
	IAudienceSegmentType,
	IFrequency,
} from 'Components/flowChart/components/NodePreview/components/NodeScheduled/types';

export const FREQUENCY_LABEL: Record<IFrequency, string> = {
	once: 'Once',
	hourly: 'hour',
	daily: 'day',
	weekly: 'week',
	monthly: 'month',
};

export const SEGMENT_TYPE_LABEL: Record<IAudienceSegmentType, string> = {
	customer_segment: 'customer',
	user_segment: 'visitor',
};
